import { defineStore } from "pinia";

export const useChartStore = defineStore('chart', () => {
  let idCounter = 0
  const getNextId = () => idCounter++


  return {
    getNextId
  }
})